import { Box } from "@mui/material";
import React, { ReactNode } from "react";
import useTheme from "../../../../../../../common/hooks/useTheme";
import { Theme } from "../../../../../../../providers/ThemeProvider";

type WidgetProps = {
  title: string;
  value: ReactNode;
};

/** The mobile `WorkoutGeneralWidget`: a framed title-above-value tile. */
export const DetailWidget = ({ title, value }: WidgetProps) => {
  const theme: Theme = useTheme();
  return (
    <Box sx={styles.widget(theme)}>
      <Box sx={styles.title(theme)}>{title}</Box>
      <Box sx={styles.value(theme)}>{value}</Box>
    </Box>
  );
};

type GridProps = {
  children: ReactNode;
};

/** Two tiles per row, as the mobile details screens lay them out. */
export const DetailWidgetGrid = ({ children }: GridProps) => (
  <Box sx={styles.grid}>{children}</Box>
);

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "8px",
  },
  widget: (theme: Theme) => ({
    display: "flex",
    flexDirection: "column" as "column",
    gap: "8px",
    minHeight: "72px",
    padding: "12px",
    borderRadius: "8px",
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
  }),
  title: (theme: Theme) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    lineHeight: "20px",
  }),
  value: (theme: Theme) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    lineHeight: "20px",
  }),
};
